import classNames from 'classnames';
import { IntlKey } from 'locales';
import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

export interface QuoteStatusProps {
  className?: string;
  icon?: ReactNode;
  description?: IntlKey;
  remainingTimeInSeconds?: number;
  action?: ReactNode;
}

export const QuoteStatus: FC<QuoteStatusProps> = ({
  className,
  icon,
  description,
  remainingTimeInSeconds = 0,
  action,
}) => {
  const minute = Math.floor(remainingTimeInSeconds / 60);
  const second = remainingTimeInSeconds - minute * 60;

  return (
    <div className={classNames(className, 'd-flex align-items-center w-100 p-0 rounded-bottom-1')}>
      <div className="d-flex align-items-center justify-content-center" style={{ width: 40 }}>
        {typeof icon === 'string' ? <i className="icon icon-md">{icon}</i> : icon}
      </div>
      <span className="flex-grow-1 fw-medium">
        {description && <FormattedMessage id={description} values={{ minute, second }} />}
      </span>
      <div className="d-flex flex-shrink-0">{action}</div>
    </div>
  );
};
